import React, { useEffect, useRef, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

interface TableDataProps {
  children: string | JSX.Element;
}

const useStyles = makeStyles(() => ({
  tooltip: {
    maxWidth: '320px',
    bottom: '30px',
    backgroundColor: '#4D4D4D',
  },
  arrow: {
    color: '#4D4D4D',
  },
  popper: {
    zIndex: 99999,
  },
}));

const TableData = ({ children }: TableDataProps) => {
  const [isOverflowed, setIsOverflow] = useState(false);
  const [, setWidth] = useState(window.innerWidth);

  const classes = useStyles();

  const tableDataRef = useRef<HTMLTableDataCellElement>(
    document.createElement('td'),
  );

  const getWindowWidth = () =>
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  useEffect(() => {
    const resizeListener = () => {
      setWidth(getWindowWidth);
      setIsOverflow(
        tableDataRef.current.scrollWidth > tableDataRef.current.clientWidth,
      );
    };
    setIsOverflow(
      tableDataRef.current.scrollWidth > tableDataRef.current.clientWidth,
    );
    window.addEventListener('resize', resizeListener);
    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  return (
    <Tooltip
      disableHoverListener={!isOverflowed}
      title={children}
      arrow
      classes={classes}
    >
      <td
        ref={tableDataRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 0,
        }}
      >
        {children}
      </td>
    </Tooltip>
  );
};

export default TableData;
